import { SubAccountTransactionsHistoryRequest, SubAccountTransactionsHistoryResponse } from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useFetchSubAccountTransactions() {
    const source = axios.CancelToken.source();
    const [transactions, setTransactions] = useState<SubAccountTransactionsHistoryResponse>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();
    const fetchTransactions = async (requestParams: SubAccountTransactionsHistoryRequest) => {
      setDataFetchingInfo(true);

      const res = await api.getSubAccountTransactionsHistory(requestParams, source);

      setTransactions(res);
      setDataFetchingInfo(false);

      return res;
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      transactions,
      fetchTransactions,
    };
  };
});

export default initHook({});
